module.exports = __webpack_public_path__ + "img/emission.73fdf172.png";